module.exports = "<div class=\"jobs-container\">\r\n  <div class=\"jobs-inner-container\">    \r\n    <div class=\"filters-container\">\r\n      <jobs-filter apply-filters=\"vm.applyFilters()\"></jobs-filter>\r\n    </div>\r\n    <div class=\"grid-container\">\r\n      <div class=\"jobs-match\">{{vm.jobsMatchCount ? vm.jobsMatchCount + \" jobs match\" : \"\"}}</div>\r\n      <div class=\"jobs-grid\">\r\n        <div id=\"jobs-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/containers/jobs/jobs.html
 ** module id = 888
 ** module chunks = 0
 **/